'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var componentsLabel = require('@keytrade/components-label');
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var colors = functions.config.colors.list;
var TYPES = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
};
var CheckedInput = function CheckedInput(_ref) {
  var checked = _ref.checked,
    children = _ref.children,
    disabled = _ref.disabled,
    labelWeight = _ref.labelWeight,
    name = _ref.name,
    onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    type = _ref.type,
    value = _ref.value,
    margin = _ref.margin;
  return /*#__PURE__*/React.createElement(componentsLabel.Label, {
    weight: labelWeight,
    noMarginBottom: true,
    margin: margin
  }, /*#__PURE__*/React.createElement(Input, {
    type: type,
    onChange: onChange,
    readOnly: readOnly,
    checked: checked,
    disabled: disabled,
    required: required,
    name: name,
    value: value
  }), /*#__PURE__*/React.createElement(LabelWrapper, {
    type: type
  }, /*#__PURE__*/React.createElement(LabelInner, null, children)));
};
var Input = styled.input.withConfig({
  displayName: "CheckedInput__Input",
  componentId: "sc-11679tc-0"
})(["position:absolute;z-index:-1;opacity:0;top:0;left:0;&[readOnly],&[disabled]{& + span{&::before{cursor:not-allowed;background-color:", ";}&::after{", "}}}&:not([disabled]):hover,&:not([disabled]):focus{+ span::before{box-shadow:0 0 .4rem 0 ", ";}}&:not([disabled]):focus + span::before{border-color:", ";}&:checked + span::after{opacity:1;}"], colors.GreyWhite, function (props) {
  return props.type === TYPES.RADIO ? "\n          background-color: ".concat(colors.GreyLight, ";\n        ") : "\n          background-image: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScycmVtJyBoZWlnaHQ9JzJyZW0nIHZpZXdCb3g9JzAgMCAyNCAyNCc+CiAgICA8cGF0aCBmaWxsPScjRDhEOEQ4JyBmaWxsUnVsZT0nZXZlbm9kZCcgZD0nTTEwLjA5NSAxNy43NjFMNS4yMiAxMi41MzRhLjg0Ni44NDYgMCAwIDEgMC0xLjEzN2wxLjA2LTEuMTM3YS43MTUuNzE1IDAgMCAxIDEuMDYxIDBsMy4yODQgMy41MiA3LjAzNC03LjU0MWEuNzE1LjcxNSAwIDAgMSAxLjA2IDBsMS4wNjEgMS4xMzdhLjg0Ni44NDYgMCAwIDEgMCAxLjEzN2wtOC42MjUgOS4yNDhhLjcxNS43MTUgMCAwIDEtMS4wNiAweicgLz4KICA8L3N2Zz4=\");\n        ";
}, colors.BlueCloudyTransparent, colors.BlueCloudy);
var LabelWrapper = styled.span.withConfig({
  displayName: "CheckedInput__LabelWrapper",
  componentId: "sc-11679tc-1"
})(["position:relative;display:inline-block;padding-left:2.7rem;&::before{cursor:pointer;content:'';width:1.8rem;height:1.8rem;margin-left:-2.6rem;background-color:", ";border:.1rem solid ", ";border-radius:", ";vertical-align:middle;margin-right:0.7rem;display:inline-block;position:absolute;}&::after{content:'';opacity:0;display:block;position:absolute;pointer-events:none;", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.dark ? colors.BlueDark : colors.White;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.dark ? colors.GreyBlue : colors.GreyLight;
}, function (_ref4) {
  var type = _ref4.type;
  return type === TYPES.RADIO ? "50%" : ".3rem";
}, function (_ref5) {
  var type = _ref5.type;
  return type === TYPES.RADIO ? "\n      top: .4rem;\n      left: .5rem;\n      background-color: ".concat(colors.BlueSky, ";\n      border-radius: 50%;\n      width: 1rem;\n      height: 1rem;\n      ") : "\n      top: 0;\n      left: .1rem;\n      width: 1.8rem;\n      height: 1.8rem;\n      /* Base64-encoded version of icn_checkBold */\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%2300B3DB' fill-rule='evenodd' d='M10.095 17.761L5.22 12.534a.846.846 0 0 1 0-1.137l1.06-1.137a.715.715 0 0 1 1.061 0l3.284 3.52 7.034-7.541a.715.715 0 0 1 1.06 0l1.061 1.137a.846.846 0 0 1 0 1.137l-8.625 9.248a.715.715 0 0 1-1.06 0z'/%3E%3C/svg%3E%0A\");\n      background-repeat: no-repeat;\n      background-size: contain;\n    ";
});
var LabelInner = styled.span.withConfig({
  displayName: "CheckedInput__LabelInner",
  componentId: "sc-11679tc-2"
})(["display:inline-block;", ""], function (props) {
  return props.theme.type === 'secure' && 'margin-top: .2rem;';
});
CheckedInput.defaultProps = {
  checked: false,
  disabled: false,
  labelWeight: 'regular',
  readOnly: false,
  required: false
};
var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/React.createElement(CheckedInput, _extends({}, props, {
    type: TYPES.CHECKBOX
  }));
};
var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/React.createElement(CheckedInput, _extends({}, props, {
    type: TYPES.RADIO
  }));
};
var _excluded = ["radio"],
  _excluded2 = ["row"];
var getFont = functions.config.fonts.getFont;
var colors$1 = functions.config.colors.list;
var CheckedInputGroupWrapper = styled.div.withConfig({
  displayName: "CheckedInputGroup__CheckedInputGroupWrapper",
  componentId: "sc-1gkq3d0-0"
})(["", ""], function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
});
var ErrorWrapper = styled.p.withConfig({
  displayName: "CheckedInputGroup__ErrorWrapper",
  componentId: "sc-1gkq3d0-1"
})(["margin:", ";color:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.type === 'secure' ? '.2rem 0 0' : '.4rem 0 0';
}, colors$1.Tomato, function (props) {
  return props.theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' ? '1.6rem' : '1.8rem';
});
var GroupLabel = styled.p.withConfig({
  displayName: "CheckedInputGroup__GroupLabel",
  componentId: "sc-1gkq3d0-2"
})(["margin:0;font-family:", ";font-size:", ";line-height:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return getFont(theme, 'semiBold');
}, function (props) {
  return props.theme.type === 'secure' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' ? '1.6rem' : '1.8rem';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.dark ? colors$1.White : colors$1.BlueDark;
});
var CheckedInputGroupBorderWrapper = styled.div.withConfig({
  displayName: "CheckedInputGroup__CheckedInputGroupBorderWrapper",
  componentId: "sc-1gkq3d0-3"
})(["margin-top:.6rem;border:.1rem solid ", ";border-radius:.5rem;background-color:", ";> *{padding:1.2rem;margin:0;&:not(:last-child){border-bottom:.1rem solid ", ";}}"], colors$1.GreyLight, colors$1.White, colors$1.GreyLight);
var ShowIfSelectedWrapper = styled.div.withConfig({
  displayName: "CheckedInputGroup__ShowIfSelectedWrapper",
  componentId: "sc-1gkq3d0-4"
})(["margin:.8rem 0 0 2.6rem;"]);
var OptionItem = styled.div.attrs({
  className: 'OptionItem'
}).withConfig({
  displayName: "CheckedInputGroup__OptionItem",
  componentId: "sc-1gkq3d0-5"
})([""]);
var IsInlineWrapper = styled.div.attrs({
  className: 'InlineWrapper'
}).withConfig({
  displayName: "CheckedInputGroup__IsInlineWrapper",
  componentId: "sc-1gkq3d0-6"
})(["display:flex;flex-direction:row;gap:2.2rem;"]);
var CheckedInput$1 = function CheckedInput(_ref3) {
  var radio = _ref3.radio,
    props = _objectWithoutProperties(_ref3, _excluded);
  return radio ? /*#__PURE__*/React.createElement(RadioButton, props) : /*#__PURE__*/React.createElement(Checkbox, props);
};
var IsInline = function IsInline(_ref4) {
  var row = _ref4.row,
    props = _objectWithoutProperties(_ref4, _excluded2);
  return row ? /*#__PURE__*/React.createElement(IsInlineWrapper, null, props.children) : props.children;
};
var CheckedInputGroup = function CheckedInputGroup(props) {
  var withBorders = props.options.some(function (option) {
    return option.showIfSelected;
  });
  var renderCheckedInputs = function renderCheckedInputs() {
    return props.options.map(function (option) {
      return /*#__PURE__*/React.createElement(OptionItem, {
        key: option.value
      }, /*#__PURE__*/React.createElement(CheckedInput$1, {
        radio: props.radio,
        name: props.name,
        labelWeight: "regular",
        required: true,
        checked: Array.isArray(props.value) ? props.value.includes(option.value) : props.value === option.value,
        value: option.value,
        onChange: props.onChange,
        margin: !withBorders && '.8rem 0',
        disabled: option.disabled
      }, option.label), option.showIfSelected && (Array.isArray(props.value) ? props.value.includes(option.value) : props.value === option.value) && /*#__PURE__*/React.createElement(ShowIfSelectedWrapper, null, option.showIfSelected));
    });
  };
  return /*#__PURE__*/React.createElement(CheckedInputGroupWrapper, {
    margin: props.margin,
    className: props.className
  }, /*#__PURE__*/React.createElement(GroupLabel, null, props.label), withBorders ? /*#__PURE__*/React.createElement(CheckedInputGroupBorderWrapper, null, /*#__PURE__*/React.createElement(IsInline, {
    row: props.row
  }, renderCheckedInputs())) : /*#__PURE__*/React.createElement(IsInline, {
    row: props.row
  }, renderCheckedInputs()), props.errorMessage && /*#__PURE__*/React.createElement(ErrorWrapper, null, props.errorMessage));
};
var CheckboxGroup = function CheckboxGroup(props) {
  return /*#__PURE__*/React.createElement(CheckedInputGroup, props);
};
var RadioGroup = function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(CheckedInputGroup, _extends({}, props, {
    radio: true
  }));
};
exports.Checkbox = Checkbox;
exports.RadioButton = RadioButton;
exports.CheckboxGroup = CheckboxGroup;
exports.RadioGroup = RadioGroup;